import { render } from "./image.html?vue&type=template&id=785d6224&scoped=true&external"
import script from "./images.vue?vue&type=script&lang=js"
export * from "./images.vue?vue&type=script&lang=js"

import "./images.vue?vue&type=style&index=0&id=785d6224&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785d6224"]])

export default __exports__